import React from "react";

type ContainerProps = {
  children: React.ReactNode;
  isPage?: boolean;
};

const Container = (props: ContainerProps) => {
  return (
    <div
      className={`mx-auto px-6 sm:px-8 md:px-4 xl:px-0 sm:max-w-[90vw] xl:max-w-[87vw] 2xl:max-w-[85vw] 3xl:max-w-[85vw] 4xl:max-w-[1900px] ${
        props.isPage ? "py-8" : ""
      }`}
    >
      {props.children}
    </div>
  );
};

export default Container;
